import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		zIndex: "var(--popover-z-index)",
	},
	trigger: {
		margin: "0px",
		padding: "0px",
		border: "0px",
		cursor: "pointer",
		backgroundColor: tokens.colorTransparentBackground,
	},
});
